import type {
    FutureStockQuantities,
    ProductOrderRestriction,
    StockQuantity,
} from '../../availability/types';
import type Category from '../../core/types/category';
import type { ProductCustomerPrice, ProductItem } from '../types';

export interface FilterList {
    name: string;
    values: string[];
    slug?: string;
    label?: string;
    valueLabels?: string[];
}

export interface CategoryBreakdown {
    category: Category;
    total: number;
}

export interface ProductListQueryResult {
    products: {
        items: ProductItem[];
        total: number;
        prices: ProductCustomerPrice[];
        stockQuantities: StockQuantity[];
        futureStockQuantities: FutureStockQuantities[];
        productOrderRestrictions: ProductOrderRestriction[] | null;
    };
    defaultValue?: boolean;
}

export interface RootCategoriesQueryResult {
    rootCategories: {
        categories: CategoryBreakdown[];
    };
}

export enum ProductState {
    ON_SALE = 'onSale',
    IS_NEW = 'isNew',
}

export interface ProductListQueryFilters {
    pageSize?: number;
    skip?: boolean;
    onSale?: boolean;
    states?: ProductState[];
    searchTerm?: string;
    filters?: FilterList[];
    vehicleSearchId?: string;
    bicycleSearchId?: string;
    rootTree?: boolean;
    preorderSeasonId?: number;
    includePreorderSeasonId?: number;
    ignoreCategoryIdFromUrl?: boolean;
}
